import type { IconProps } from "@codat/orchard-ui//dist/es/icons/types";

export function EyeIcon({
  fillColor = "currentColor",
  ...props
}: IconProps): JSX.Element {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 11" {...props}>
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M 15.68,4.80
           C 14.55,3.55 11.60,0.67 8.00,0.67
             4.40,0.67 1.40,3.55 0.32,4.80
             -0.11,5.27 -0.11,6.01 0.32,6.53
             1.45,7.79 4.40,10.67 8.00,10.67
             11.60,10.67 14.60,7.79 15.68,6.53
             16.11,6.01 16.11,5.27 15.68,4.80 Z
           M 4.35,7.89
           C 3.11,7.16 2.15,6.22 1.66,5.64
             2.15,5.12 3.11,4.17 4.35,3.39
             3.92,4.02 3.70,4.80 3.70,5.64
             3.70,6.48 3.97,7.21 4.35,7.89 Z
           M 8.00,8.78
           C 6.23,8.78 4.78,7.37 4.78,5.64
             4.78,3.91 6.23,2.50 8.00,2.50
             9.77,2.50 11.22,3.91 11.22,5.64
             11.22,7.37 9.77,8.78 8.00,8.78 Z
           M 11.65,7.89
           C 12.08,7.26 12.30,6.48 12.30,5.64
             12.30,4.80 12.03,4.07 11.65,3.39
             12.89,4.12 13.85,5.06 14.34,5.64
             13.80,6.16 12.83,7.11 11.65,7.89 Z
           M 9.61,5.64
           C 9.61,6.53 8.91,7.21 8.00,7.21
             7.09,7.21 6.39,6.53 6.39,5.64
             6.39,5.43 6.44,5.27 6.50,5.12
             6.55,5.12 6.60,5.12 6.66,5.12
             7.09,5.12 7.46,4.75 7.46,4.33
             7.46,4.28 7.46,4.23 7.46,4.17
             7.62,4.12 7.84,4.07 8.00,4.07
             8.91,4.07 9.61,4.75 9.61,5.64 Z"
      />
    </svg>
  );
}
